import { html } from 'lit-html';
import { repeat } from 'lit-html/directives/repeat';
import { TilesVariantSelectorBase } from "./tiles-variant-selector-base.js";
import { IProductWithVariants, IVariant } from './variant-selector-base.js';

const $ = window.jQuery;
const pubsub = window.PubSub;

export class FancyBoxTilesVariantSelectorV1 extends TilesVariantSelectorBase {
    private $mainContainer: any;
    private $previewImage: any;
    private $previewName: any;
    private $selectedVariantImage: any;
    private $selectVariantBtn: any;

    constructor(name: string, selectorContainerElement: HTMLElement, product: IProductWithVariants, variantTypeId: number, translations: Map<string, string>, showPricesInclVat: boolean, loadAdditionalInfo: boolean) {
        super(name, selectorContainerElement, product, variantTypeId, translations, showPricesInclVat, loadAdditionalInfo);
        this.$mainContainer = $(selectorContainerElement);
    }
    protected template = () => html`
        <div class="c-fancyboxrelimgtilesvariant">
            <button type="button" class="c-fancyboxrelimgtilesvariant__preview-btn" data-fancybox data-src="#${this.variantSelectorData.variantUniqueId}">
                <figure class="c-fancyboxrelimgtilesvariant__image js-selected-variant-image"></figure>
                <div class="js-select-variant-label">
                    ${this.variantSelectorData.variants.length > 1 ? this.variantSelectorData.labels.select : '' } ${this.variantSelectorData.variantTypeName}
                </div>
            </button>
        </div>
        <div class="c-fancyboxrelimgtilesvariant__popup" style="display:none" id="${this.variantSelectorData.variantUniqueId}">
            <div class="c-fancyboxrelimgtilesvariant__popup-content">
                <div class="c-fancyboxrelimgtilesvariant__popup-list">
                ${repeat(this.variantSelectorData.variants, (variant:IVariant) => html`
                    <button type="button" class="c-fancyboxrelimgtilesvariant__option js-variant" data-variantid="${variant.id}">
                        <figure class="c-fancyboxrelimgtilesvariant__image js-variant-image" ${variant.image ? `style="background-image:url(${variant.image.thumbnailUrl})"` : ''}>
                            <div class="c-fancyboxrelimgtilesvariant__unavailable-text js-unavailable-text-container" style="display:none;">
                                <span class="c-fancyboxrelimgtilesvariant__unavailable-text-label js-unavailable-text"></span>
                            </div>
                        </figure>
                        <div class="c-fancyboxrelimgtilesvariant__name js-variant-name">${variant.name}</div>
                    </button>`
                )}
                </div>
                <div class="c-fancyboxrelimgtilesvariant__preview">
                    <figure class="c-fancyboxrelimgtilesvariant__image js-variant-preview-image"></figure>
                    <div class="c-fancyboxrelimgtilesvariant__preview-properties">
                        <div class="c-fancyboxrelimgtilesvariant__name js-variant-preview-name"></div>
                        <button type="button" class="c-fancyboxrelimgtilesvariant__select-btn js-select-variant-btn btn btn-primary">${this.variantSelectorData.labels.select}</button>
                    </div>
                </div>
            </div>
        </div>`;

    protected getDataBeforeRender(): any {
        const self = this;
 
        const result = {
            variantTypeName: this.variantType.name,
            variants: this.sortVariants(this.selectorContainerElement, this.variantType.variants, this.product),
            labels: { select: this.translations.get('selectVariantPrefix'), changeSelection: this.translations.get('changeSelectionVariantPrefix') },
            variantUniqueId: this.product.uniqueId + '_' + this.variantType.id
        };

        if (self.product.relatedImages && self.product.relatedImages.length > 0) {
            result.variants.forEach(function (variant: any) {
                const variantName = typeof (variant.name.normalize) === 'function' ? variant.name.normalize() : variant.name;
                const variantNameRegex = RegExp(self.product.variantRelImageMatchRegExp.replace('VARIANTNAME', variantName), 'gi');

                var relatedImage = self.product.relatedImages.find(function (relImg) {
                    var imageName = typeof (relImg.title.normalize) === 'function' ? relImg.title.normalize() : relImg.title;
                    return variantNameRegex.test(imageName);
                });

                if (relatedImage) {
                    variant.image = relatedImage;
                }
            });
        }

        return result;
    }

    protected processAfterRender(): void {
        const self = this;

        self.$variants = self.$mainContainer.find('.js-variant');
        self.$previewImage = self.$mainContainer.find('.js-variant-preview-image');
        self.$previewName = self.$mainContainer.find('.js-variant-preview-name');
        self.$selectedVariantImage = self.$mainContainer.find('.js-selected-variant-image');
        self.$selectVariantBtn = self.$mainContainer.find('.js-select-variant-btn');

        self.$variants.on('click', function (evt) {
            evt.preventDefault();

            var $variantToSelect = $(this);
            self._setPreview($variantToSelect);
        });

        self.$selectVariantBtn.on('click', function (evt) {
            evt.preventDefault();

            var $variantToSelect = self.$variants.filter('.selected').removeClass('selected');
            self.setSelectedInternal($variantToSelect);

            $.fancybox.close();
        });

        pubsub.publish('variantprocessor.variant.render', { variant: self.variantSelectorData, container: self.$mainContainer });
    }

    protected setSelectedInternal($variantToSelect: any) {
        var isVariantAlreadySelected = $variantToSelect.hasClass('selected');
        this.$selectedVariantImage.removeAttr('style').hide();

        var currentVariantValue = null;
        if (!isVariantAlreadySelected) {
            currentVariantValue = $variantToSelect.data('variantid');
            if (currentVariantValue > 0 && $variantToSelect.find('.js-variant-image').css('background-image') !== 'none') {
                this.$selectedVariantImage.attr('style', $variantToSelect.find('.js-variant-image').attr('style')).show();
            }
        }

        this._setPreview($variantToSelect);

        var isSelectedOptionAvailable = this.isSelectedAvailable();
        this.$mainContainer.trigger(this.VARIANT_CHANGED_EVENT, [this.variantType, currentVariantValue || 0, isSelectedOptionAvailable, this.product.productId]);

        this.setVariantSelectorLabelPrefix(this.getSelected() > 0
            ? this.variantSelectorData.labels.changeSelection
            : this.variantSelectorData.labels.select);
    }

    private _setPreview($variantToSelect) {
        var isVariantAlreadySelected = $variantToSelect.hasClass('selected');

        this.$variants.removeClass('selected');
        this.$previewImage.removeAttr('style');
        this.$previewName.empty();

        if (!isVariantAlreadySelected) {
            $variantToSelect.addClass('selected');
            this.$previewImage.attr('style', $variantToSelect.find('.js-variant-image').attr('style'));
            this.$previewName.append($variantToSelect.find('.js-variant-name').text());
        }
    }
}
